// Pure text-normalization helpers. No DOM, no app state — safe to unit test
// directly. Extracted verbatim from public/index.html's inline script as
// part of the Phase 2 modularization (see REFACTOR_SECURITY_REPORT.md).
export function stripAccents(s) {
  return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '');
}

export function norm(s) {
  return stripAccents((s || '').toLowerCase()).replace(/\s+/g, ' ').trim();
}
